import { render, staticRenderFns } from "./ServicesClass.vue?vue&type=template&id=71ff7b4a&scoped=true&"
import script from "./ServicesClass.vue?vue&type=script&lang=js&"
export * from "./ServicesClass.vue?vue&type=script&lang=js&"
import style0 from "./ServicesClass.vue?vue&type=style&index=0&id=71ff7b4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ff7b4a",
  null
  
)

export default component.exports